import { NotificationEventType } from "../../redux/services/notifications";

export const notificationHeadings: Record<NotificationEventType, string> = {
    CREATED: "Created",
    UPDATED: "Updated",
    VERSION_UPDATED: "Version Updated",
    CLONED: "Cloned",
    DELETED: "Deleted",
    PUBLISHED: "Published",
    ATTACHMENT_ADDED: "Attachment Added",
    ATTACHMENT_REMOVED: "Attachment Removed",
    ACCESS_GRANTED: "Access Granted",
    ACCESS_REVOKED: "Access Revoked",
    USER_ASSIGNED: "User Assigned",
    USER_UNASSIGNED: "User Unassigned",
};
